export default __webpack_public_path__ + "static/imgTreepng-d123a54ffc6ff2e63ef978da0fbc8645.png";